module.exports = __webpack_public_path__ + "img/zx.9adc2add.png";